import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { delete_icon, edit_icon, NoImage, Search_icon } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import CustomModal from "../../components/Model/Model";
import Select from "react-select";
import { Autocomplete, TextField, Chip, Alert } from "@mui/material";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { checkPermission } from "../redux/api/PermissionManager";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import GoogleMapPage from "../../components/Map/GoogleMap";

export default function MasterLocation() {
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const { paginationData, setpaginationData } = useGlobalContext();
  const [formData, setFormData] = useState({
    country: "India",
    state: "",
    area: "",
    city: "",
    latitude: "",
    longitude: "",
    image: "",
  });
  const [formFilter, setFormFilter] = useState({
    state: "",
    city: "",
  });
  const [label, setLabel] = useState(paginationData?.[path]?.active ?? "State");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const [type, setType] = useState();
  const [open, setOpen] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [parentId, setParentId] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [citysOptions, setCitysOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  // State data
  const [stateName, setStateName] = useState("");
  const [owners, setOwners] = useState([]);
  const [totalCount, setTotalCount] = useState();

  // City data
  const [cities, setCities] = useState([]);

  // Area data
  const [areas, setAreas] = useState([]);

  // Area data
  const [popularArea, setPopularArea] = useState([]);

  const storePaginationData = (activeTab) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], active: activeTab },
    }));
  };

  const fetch = async (page = 1) => {
    let type = null;

    if (label === "State") type = 2;
    if (label === "City") type = 3;
    if (label === "Area") type = 4;
    if (label === "Popular Area") type = 4;

    if (!type) return; // no valid label, just exit

    let stateFilter = "";
    let cityFilter = "";

    if (label === "City") {
      stateFilter = formFilter?.state || "";
    } else if (label === "Area" || label === "Popular Area") {
      cityFilter = formFilter?.city || "";
      stateFilter = formFilter?.state || "";
    }

    // ✅ Build query params safely (handles encoding automatically)
    const params = new URLSearchParams();
    params.set("type", type);

    if (search) params.set("search", search);
    if (label === "Popular Area") params.set("is_popular", "true");

    if (label === "City" && stateFilter) {
      params.set("parent_id", stateFilter);
    } else if (label === "Area" || label === "Popular Area") {
      if (cityFilter) params.set("parent_id", cityFilter);
      if (stateFilter) params.set("state_id", stateFilter);
    }

    params.set("page", page);

    const url = `${URLS.MASTERLOCATION}?${params.toString()}`;

    try {
      const res = await get(url);
      toast.success(res?.message);
      setTotalCount(res?.count);

      if (label === "State") setOwners(res?.data || []);
      if (label === "City") setCities(res?.data || []);
      if (label === "Area") setAreas(res?.data || []);
      if (label === "Popular Area") {
        const resPopular = res?.data?.filter(
          (item) => item.is_popular === true,
        );
        setPopularArea(resPopular || []);
      }

      // ✅ Always compute pagination from the returned count.
      // The backend paginates search/filtered results too, so
      // pagination controls should stay available whenever more
      // than one page exists — regardless of whether search,
      // stateFilter, or cityFilter is active.
      const pageSize = 10;
      const lastPage = Math.ceil((res?.count || 0) / pageSize);

      setPagination({
        current_page: page,
        last_page: lastPage,
      });
    } catch (err) {
      console.log("err", err);
    }
  };

  const fetchStateCityArea = async (type, parent) => {
    const res = await get(
      `${URLS.LOCATION}?type=${type}${parent ? "&parent_id=" + parent : ""}`,
    );

    const isPopular = res.data.filter((item) => item.is_popular === false);

    let mappedOptions;

    if (label === "Popular Area") {
      mappedOptions =
        isPopular.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
    } else {
      mappedOptions =
        res?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
    }

    if (type == 2) {
      setStateOptions(mappedOptions);
    }
    if (type == 3) {
      setCitysOptions(mappedOptions);
    }
    if (type == 4) {
      setAreaOptions(mappedOptions);
    }
  };

  const fetchView = async (id) => {
    try {
      const res = await get(`${URLS.MASTERLOCATION}${id}/`);

      if (label === "State") {
        setStateName(res?.data?.name);
      }
      if (label === "City") {
        setFormData({
          state: res?.data?.state_name || "",
          latitude: res?.data?.latitude || "",
          longitude: res?.data?.longitude || "",
          image: res?.data?.image || "",
          city: res?.data?.name || "",
        });
      }
      if (label === "Area") {
        setFormData({
          state: res?.data?.state_name || "",
          latitude: res?.data?.latitude || "",
          longitude: res?.data?.longitude || "",
          city: res?.data?.city_name || "",
          area: res?.data?.name || "",
        });
      }
      if (label === "Popular Area") {
        setFormData({
          state: res?.data?.state_name || "",
          latitude: res?.data?.latitude || "",
          longitude: res?.data?.longitude || "",
          city: res?.data?.city_name || "",
          area: res?.data?.name || "",
        });
        setSelectedAreas(
          res?.data ? [{ value: res.data.id, label: res.data.name }] : [],
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setPage(1);
  }, [label]);

  useEffect(() => {
    fetch(page);
  }, [search, page, label, parentId, formFilter]);

  useEffect(() => {
    fetchStateCityArea(2);
  }, []);

  useEffect(() => {
    if (formData.state) {
      const find = stateOptions?.find((item) => item?.value == formData.state);
      fetchStateCityArea(3, find?.value);
    }
  }, [formData.state]);

  useEffect(() => {
    if (formData.city) {
      const find = citysOptions?.find((item) => item?.value == formData.city);
      fetchStateCityArea(4, find?.value);
    }
  }, [formData.city]);

  useEffect(() => {
    if (formFilter.state) {
      const find = stateOptions?.find(
        (item) => item?.value == formFilter.state,
      );
      fetchStateCityArea(3, find?.value);
    }
  }, [formFilter.state]);

  useEffect(() => {
    if (formFilter.city) {
      const find = citysOptions?.find((item) => item?.value == formFilter.city);
      fetchStateCityArea(4, find?.value);
    }
  }, [formFilter.city]);

  useEffect(() => {
    if (editId && type === "edit") {
      fetchView(editId);
    }
  }, [editId, type]);

  const handleDelete = async () => {
    setLoading(true);

    if (label === "Popular Area") {
      const ids = [editId];

      const res = await post(`${URLS.MASTERLOCATION}unpopular/`, { ids: ids });
      if (res.status === "success") {
        toast.success(res?.message);
      }
      fetch(page);
      setFormData({});
      setSelectedAreas([]);
      handleClose();
      setDeletePopup(false);
    } else if (editId) {
      try {
        const res = await post(`${URLS.MASTERLOCATION}${editId}/delete/`);
        if (res.status === "success") {
          toast.success(res?.message);
        }
        setDeletePopup(false);
        fetch(page);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOpen = () => {
    setCitysOptions([]);
    setSelectedAreas([]);
    setIsEdit(false);
    setType("add");
    setFormData({
      country: "India",
      state: "",
      city: "",
      latitude: "",
      longitude: "",
    });
    setStateName("");
    setOpen(true);
  };

  const handleEdit = (row) => {
    if (label === "State") {
      setStateName(row.original.State);
    } else if (label === "City") {
      setFormData({
        country: "India",
        state: row.original.State,
        city: row.original.City,
        latitude: row.original.Latitude,
        longitude: row.original.Longitude,
      });
    }
    setIsEdit(true);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleStatus = async ({ id, status }) => {
    try {
      const res = await post(`${URLS.MASTERLOCATION}${id}/status/`, {
        status: !status,
      });
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetch(page);
        fetchStateCityArea(2);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const handleAddAreas = async () => {
    if (!selectedAreas || selectedAreas.length === 0) {
      toast.error("Please select at least one area");
      return;
    }

    const ids = selectedAreas.map((area) => area.value);

    const res = await post(`${URLS.MASTERLOCATION}popular/`, { ids: ids });
    if (res.status === "success") {
      toast.success(res.message || "added successfully");
    }
    fetch(page);
    setFormData({});
    setSelectedAreas([]);
    setAreaOptions([]);
    handleClose();
  };

  const handleAdd = async () => {
    // ✅ Common validation checks
    if (label === "State" && !stateName) {
      toast.error("Please Enter State");
      return;
    }

    if (label !== "State") {
      if (!formData.state) {
        toast.error("Please Enter State");
        return;
      }
      if (!formData.city) {
        toast.error("Please Enter City");
        return;
      }
      if (label === "City" || label === "Area") {
        if (!formData.latitude) {
          toast.error("Please Enter Latitude");
          return;
        }
        if (!formData.longitude) {
          toast.error("Please Enter Longitude");
          return;
        }
      }
    }

    if (label === "City" && !formData.image) {
      toast.error("Please Choose Image");
      return;
    }

    if (label === "Area" && !formData.area) {
      toast.error("Please Enter Area");
      return;
    }

    if (
      label === "Popular Area" &&
      (!selectedAreas || selectedAreas.length === 0)
    ) {
      toast.error("Please select at least one area.");
      return;
    }

    try {
      setLoading(true);

      const selectedStateId =
        stateOptions.find(
          (opt) => opt.value === formData.state || opt.label === formData.state,
        )?.value || null;

      const selectedCityId = citysOptions.find(
        (opt) => opt.value === formData.city || opt.label === formData.city,
      )?.value;

      const formdata = new FormData();
      // ✅ type mapping
      const typeMap = {
        State: 2,
        City: 3,
        Area: 4,
        "Popular Area": 4,
      };

      formdata.append("type", typeMap[label]);

      // ✅ Append fields depending on label
      if (label === "State") {
        formdata.append("name", stateName);
        formdata.append("county", 1);
      }

      if (label === "City") {
        formdata.append("parent", selectedStateId || "");
        formdata.append("county", 1);
        formdata.append("latitude", formData.latitude);
        formdata.append("longitude", formData.longitude);
        formdata.append("image", formData.image);
        formdata.append("name", formData.city);
      }

      if (label === "Area") {
        formdata.append("state", formData.state || "");
        formdata.append("county", 1);
        formdata.append("parent", selectedCityId || "");
        formdata.append("name", formData.area);
        formdata.append("latitude", formData.latitude);
        formdata.append("longitude", formData.longitude);
      }

      if (label === "Popular Area") {
        formdata.append("state", formData.state || "");
        formdata.append("county", 1);
        formdata.append("parent", formData.city || "");
        formdata.append("is_popular", true);
      }

      // ✅ API call (add / edit)
      let res;
      if (type === "add") {
        formdata.append("status", true);
        res = await post(`${URLS.MASTERLOCATION}add/`, formdata);
      } else {
        res = await post(`${URLS.MASTERLOCATION}${editId}/edit/`, formdata);
      }

      if (res.status === "success") {
        toast.success(
          res.message ||
            `${label} ${type === "add" ? "added" : "updated"} successfully`,
        );
        fetch(page); // refresh list
        fetchStateCityArea(2);
        // reset fields
        setFormData({});
        setSelectedAreas([]);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const commonColumns = [
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value, row }) => (
        <div style={{ display: "flex" }}>
          <button
            onClick={() => {
              if (checkPermission("CAN-STATUS-LOCATION"))
                handleStatus(row.original);
            }}
            className={`${
              value === false ? "deactive-btn" : "active-btn"
            } border-0 ms-2 fs-sm-10`}
          >
            {value === false ? "De-active" : "Active"}
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      accessor: "",
      Cell: ({ row }) => (
        <div className="d-flex ac-js">
          {label !== "Popular Area" && checkPermission("CAN-EDIT-LOCATION") && (
            <button
              onClick={() => {
                handleEdit(row);
                setType("edit");
                setEditId(row.original.id);
                fetchView(row.original.id);
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
          {checkPermission("CAN-DELETE-LOCATION") && (
            <button
              onClick={() => {
                setDeletePopup(true);
                setEditId(row.original.id);
              }}
              className="cust-btn"
            >
              <img src={delete_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const stateColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "State",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    ...commonColumns,
  ];

  const cityColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "City",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    {
      Header: "State",
      accessor: "state_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Latitude",
      accessor: "latitude",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Longitude",
      accessor: "longitude",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ value }) => {
        let src = NoImage;

        if (value) {
          if (value instanceof File || value instanceof Blob) {
            src = URL.createObjectURL(value);
          } else if (typeof value === "string") {
            src = value; // already a URL string
          }
        }

        return (
          <img
            src={src}
            alt="Preview"
            style={{
              width: 45,
              height: 45,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
          />
        );
      },
    },

    ...commonColumns,
  ];

  const areaColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "City",
      accessor: "city_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "State",
      accessor: "state_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Area Name",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    ...commonColumns,
  ];

  const PopularAreaColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "City",
      accessor: "city_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "State",
      accessor: "state_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Popular Area Name",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    {
      Header: "Action",
      accessor: "",
      Cell: ({ row }) => (
        <div className="d-flex ac-js">
          {checkPermission("CAN-DELETE-LOCATION") && (
            <button
              onClick={() => {
                setDeletePopup(true);
                setEditId(row.original.id);
              }}
              className="cust-btn"
            >
              <img src={delete_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const currentColumns =
    label === "City"
      ? cityColumns
      : label === "Area"
        ? areaColumns
        : label === "Popular Area"
          ? PopularAreaColumns
          : stateColumns;
  const currentData =
    label === "City"
      ? cities
      : label === "Area"
        ? areas
        : label === "Popular Area"
          ? popularArea
          : owners;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderColor: state.isFocused ? "#333" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
      "&:hover": {
        borderColor: "#333",
      },
    }),
  };

  return (
    <>
      <Topbar header="Master" subHead="Location" />

      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26  mb-4">
          Total: {totalCount}
        </h2>
        {!(label === "State" || label === "City") &&
          checkPermission("CAN-ADD-LOCATION") && (
            <button onClick={handleOpen} className="add-btn white f2">
              + Add New
            </button>
          )}
      </div>
      <div className="d-flex ac-jf">
        <div>
          <div className="d-flex gap-3 ">
            {["State", "City", "Area", "Popular Area"].map((ele) => (
              <div
                className="nowrap f2"
                key={ele}
                style={{
                  background: label === ele ? "#6B00D8" : "none",
                  color: label === ele ? "#fff" : "#898989",
                  padding: "10px 16px",
                  borderRadius: 9,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  storePaginationData(ele);
                  setLabel(ele);
                  setSearch("");
                  setPage(1);
                  setCitysOptions([]);
                  setFormFilter({
                    state: "",
                    city: "",
                  });
                }}
              >
                {ele}
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex gap-3">
          {!(label === "State") && (
            <Select
              options={stateOptions}
              placeholder="Select State"
              value={
                stateOptions.find((opt) => opt.value === formFilter.state) ||
                null
              }
              onChange={(selectedOption) => {
                setFormFilter((prev) => ({
                  ...prev,
                  state: selectedOption ? selectedOption.value : "",
                  city: "",
                }));
                setPage(1);
              }}
              isClearable
              className="location-search"
            />
          )}

          {!(label === "State" || label === "City") && (
            <Select
              options={citysOptions}
              placeholder="Select City"
              value={
                citysOptions.find((opt) => opt.value === formFilter.city) ||
                null
              }
              onChange={(selectedOption) => {
                setFormFilter((prev) => ({
                  ...prev,
                  city: selectedOption ? selectedOption.value : "", // ✅ store id
                }));
                setPage(1);
              }}
              isClearable
              className="location-search"
            />
          )}

          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" alt="search" />
          </div>
          {(label === "State" || label === "City") &&
            checkPermission("CAN-ADD-LOCATION") && (
              <button onClick={handleOpen} className="add-btn white f2">
                + Add New
              </button>
            )}
        </div>
      </div>

      <div style={{ width: "90%" }}>
        <Table
          columns={currentColumns}
          data={currentData}
          setPageno={setPage}
          pagecount={pagination}
          show={true}
        />
      </div>

      <CustomModal
        open={open}
        handleClose={handleClose}
        title={`${isEdit ? "Edit" : "Add"} ${label}`}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {label === "State" && (
            <>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    fontWeight: 600,
                    display: "block",
                    marginBottom: 10,
                  }}
                >
                  Country
                </label>
                <input className="input-box" value="India" disabled />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  State
                </label>
                <input
                  className="input-box"
                  placeholder="Enter State"
                  value={stateName}
                  onChange={(e) => setStateName(e.target.value)}
                />
              </div>
            </>
          )}

          {label === "City" && (
            <div
              style={{
                maxHeight: "55vh",
                overflowY: "auto",
                paddingRight: "10px",
                overflow: "scroll",
              }}
            >
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    fontWeight: 600,
                    display: "block",
                    marginBottom: 10,
                  }}
                >
                  Country
                </label>
                <input className="input-box" value="India" disabled />
              </div>
              {/* State Select */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  State
                </label>
                <Select
                  options={stateOptions}
                  placeholder="Select State"
                  value={
                    stateOptions.find(
                      (opt) =>
                        opt.value === formData.state ||
                        opt.label === formData.state,
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData((prev) => ({
                      ...prev,
                      state: selectedOption ? selectedOption.value : "",
                    }))
                  }
                  isClearable
                  styles={customStyles}
                />
              </div>

              {/* City Input */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  City
                </label>
                <input
                  className="input-box"
                  placeholder="City"
                  value={formData.city}
                  onChange={(e) =>
                    setFormData({ ...formData, city: e.target.value })
                  }
                />
              </div>

              {/* Latitude Input */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  Latitude
                </label>
                <input
                  type="number"
                  className="input-box"
                  placeholder="Latitude"
                  value={formData.latitude}
                  onChange={(e) =>
                    setFormData({ ...formData, latitude: e.target.value })
                  }
                />
              </div>

              {/* Longitude Input */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  Longitude
                </label>
                <input
                  type="number"
                  className="input-box"
                  placeholder="Longitude"
                  value={formData.longitude}
                  onChange={(e) =>
                    setFormData({ ...formData, longitude: e.target.value })
                  }
                />
              </div>

              {/* Image Upload */}
              <div style={{ marginBottom: 10, position: "relative" }}>
                <label
                  style={{
                    fontWeight: 600,
                    display: "block",
                    marginBottom: 12,
                  }}
                >
                  Image Upload
                </label>
                <button
                  onClick={() => setFormData({ ...formData, image: null })}
                  style={{
                    position: "absolute",
                    top: 28,
                    left: 51,
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                    fontSize: 12,
                    fontWeight: "bold",
                    lineHeight: "18px",
                    padding: 0,
                    textAlign: "center",
                  }}
                >
                  ×
                </button>
                <label
                  htmlFor="imageUpload"
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  {formData.image ? (
                    <img
                      src={
                        formData?.image instanceof File
                          ? URL.createObjectURL(formData.image) // preview local upload
                          : typeof formData?.image === "string"
                            ? formData.image // already uploaded image URL
                            : ""
                      }
                      alt="Preview"
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 8,
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : (
                    <img
                      src={NoImage}
                      alt="Preview"
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 8,
                        border: "1px solid #ccc",
                      }}
                    />
                  )}
                </label>

                <input
                  type="file"
                  id="imageUpload"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFormData({ ...formData, image: file });
                    }
                  }}
                />
              </div>
            </div>
          )}
          {(label === "Area" || label === "Popular Area") && (
            <div
              style={{
                maxHeight: "55vh",
                overflowY: "auto",
                paddingRight: "10px",
                overflow: "scroll",
              }}
            >
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    fontWeight: 600,
                    display: "block",
                    marginBottom: 10,
                  }}
                >
                  Country
                </label>
                <input className="input-box" value="India" disabled />
              </div>
              {/* State Select */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  State
                </label>
                <Select
                  options={stateOptions}
                  placeholder="Select State"
                  value={
                    stateOptions.find(
                      (opt) =>
                        opt.value === formData.state ||
                        opt.label === formData.state,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setFormData((prev) => ({
                      ...prev,
                      state: selectedOption ? selectedOption.value : "",
                    }));
                  }}
                  isClearable
                  styles={customStyles}
                />
              </div>
              {/* City Input */}
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{ fontWeight: 600, display: "block", marginBottom: 4 }}
                >
                  City
                </label>

                <Select
                  options={citysOptions}
                  placeholder="Select City"
                  value={
                    citysOptions.find(
                      (option) =>
                        option.value === formData.city ||
                        option.label === formData.city,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setFormData((prev) => ({
                      ...prev,
                      city: selectedOption ? selectedOption.value : "",
                    }));
                  }}
                  isClearable
                  styles={[customStyles]}
                />
              </div>

              {/* Area Name Input */}
              {label === "Area" ? (
                <div className="mb-1">
                  <div style={{ marginBottom: 10 }}>
                    <label
                      style={{
                        fontWeight: 600,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      Area Name
                    </label>
                    <input
                      className="input-box"
                      placeholder="Enter Area Name"
                      value={formData.area}
                      onChange={(e) =>
                        setFormData({ ...formData, area: e.target.value })
                      }
                    />
                  </div>
                  {/* Latitude Input */}
                  <div style={{ marginBottom: 10 }}>
                    <label
                      style={{
                        fontWeight: 600,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      Latitude
                    </label>
                    <input
                      type="number"
                      className="input-box"
                      placeholder="Latitude"
                      value={formData.latitude}
                      onChange={(e) =>
                        setFormData({ ...formData, latitude: e.target.value })
                      }
                    />
                  </div>

                  {/* Longitude Input */}
                  <div style={{ marginBottom: 10 }}>
                    <label
                      style={{
                        fontWeight: 600,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      Longitude
                    </label>
                    <input
                      type="number"
                      className="input-box"
                      placeholder="Longitude"
                      value={formData.longitude}
                      onChange={(e) =>
                        setFormData({ ...formData, longitude: e.target.value })
                      }
                    />
                  </div>
                  <div className="w-100">
                    <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Map<span style={{ color: "red" }}>*</span>
                    </p>
                    <GoogleMapPage
                      setFormData={setFormData}
                      edit={true}
                      latlong={{
                        lat: formData.latitude,
                        lng: formData.longitude,
                      }}
                      searchBarWidth={"90%"}
                      mapHeight={"250px"}
                    />
                  </div>
                </div>
              ) : (
                <div style={{ marginBottom: 10 }}>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: 4,
                      marginTop: 15,
                    }}
                  >
                    Area Name's
                  </label>
                  <Autocomplete
                    multiple
                    options={areaOptions}
                    getOptionLabel={(option) => option.label}
                    value={selectedAreas}
                    style={{ backgroundColor: "#F4F4F4" }}
                    onChange={(event, newValue) => {
                      setSelectedAreas(newValue);
                    }}
                    filterSelectedOptions
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.value}
                          label={option.label}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Area"
                      />
                    )}
                  />
                </div>
              )}
            </div>
          )}

          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <button className="back-btn mt-3" onClick={handleClose}>
              Cancel
            </button>
            <button
              className="submit-btn mt-3"
              onClick={label === "Popular Area" ? handleAddAreas : handleAdd}
            >
              Add
            </button>
          </div>
        </div>
      </CustomModal>

      {deletePopup && (
        <CustomModal
          open={deletePopup}
          noCancelBtn
          onConfirm={handleDelete}
          title="Are you sure you want to Delete?"
          paddingDelete={10}
        >
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <button
              style={{
                border: "1px solid #707070",
                padding: "10px 15px",
                minWidth: "40%",
                borderRadius: 5,
                background: "none",
              }}
              className="back-btn mt-3"
              onClick={() => setDeletePopup(false)}
            >
              No
            </button>
            <button
              style={{
                backgroundColor: "#5A8DFF",
                border: 0,
                padding: "10px 15px",
                minWidth: "40%",
                borderRadius: 5,
                color: "#fff",
              }}
              className="submit-btn mt-3"
              onClick={handleDelete}
            >
              Yes
            </button>
          </div>
        </CustomModal>
      )}
    </>
  );
}
